module.exports = __webpack_public_path__ + "static/media/ind_lock.6d96cfb0.png";